import { ChooseDate } from 'app/src/components/ChooseDate';
import moment from 'moment';
import PopOver from 'app/scripts/views/lib/pop-over.coffee';
import React from 'react';
import Util from 'app/scripts/lib/util/index.coffee';

interface Options {
  title: string;
  getInput: () => HTMLInputElement | HTMLTextAreaElement;
}

function bind<T extends () => unknown>(fn: T, context: unknown): T {
  return fn.bind(context);
}

export function toggleDatePopover(options: Options) {
  const { title } = options;

  return function toggle(e: MouseEvent) {
    Util.stop(e);

    const getInput = bind(options.getInput, this);

    const input = getInput();

    const initialValue = input.value;
    const dateMatch = initialValue.match(/\b\d\d\d\d-\d\d-\d\d$/);
    const existingDueDate = dateMatch && dateMatch[0];
    const momentDueDate = existingDueDate ? moment(existingDueDate) : undefined;
    const dateInitial =
      momentDueDate && momentDueDate.isValid()
        ? momentDueDate.toDate()
        : undefined;

    PopOver.toggle({
      elem: e.currentTarget,
      getViewTitle: () => title,
      keepEdits: true,
      reactElement: (
        <ChooseDate
          key="choose-date"
          {...{ dateInitial }}
          onSelect={(date) => {
            PopOver.hide();

            let dateString = '';

            if (date) {
              const formattedDate = moment(date).format('YYYY-MM-DD');

              dateString = /\s$/.test(initialValue)
                ? formattedDate
                : ` ${formattedDate}`;
            }

            const newValue = dateInitial
              ? initialValue.replace(/\s?\d\d\d\d-\d\d-\d\d$|$/, dateString)
              : initialValue + dateString;

            const selectionStart = input.selectionStart;
            const selectionEnd = input.selectionEnd;

            input.value = newValue;
            if (selectionStart !== null && selectionEnd !== null) {
              const newSelectionStart = selectionStart;
              const newSelectionEnd =
                selectionStart === 0 &&
                selectionEnd === initialValue.length &&
                selectionEnd > selectionStart
                  ? // If they've got everything selected, keep everything selected
                    newValue.length
                  : selectionEnd;

              input.setSelectionRange(newSelectionStart, newSelectionEnd);
            }

            input.focus();
          }}
        />
      ),
    });
  };
}
